import * as fromFiles from './files.state';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const getFileState = createFeatureSelector<fromFiles.FilesState>('files');
export const getDirectoryInfo = createSelector(getFileState, fromFiles.getDirectoryInfo);
export const getFolderStructure = createSelector(getFileState, fromFiles.getFolderStructure);
export const getBulkActionStatus = createSelector(getFileState, fromFiles.getBulkActionStatus);
